module.exports = __webpack_public_path__ + "img/nova-redacao.16ea2357.png";